import { useTranslation } from 'react-i18next';
import { Text } from '@hotjar/hotsauce';
import { useAuthorization } from '@hotjar/webapp/domains/authorization';
import { useEnableSessionCaptureConsent } from '../../../hooks/useEnableSessionCapture';
import {
  Container,
  Subtitle,
  TrackingButton,
} from '../../RecordingsPage/components/Console/EmptyState/styles';

type Props = {
  siteId?: number;
  onEnableCapture: () => void;
  className?: string;
};

export const NotCapturingErrors = ({ siteId, onEnableCapture, className }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { hasPermission } = useAuthorization();

  const hasSessionSettingsUpdatePermission = hasPermission(
    'site',
    `${siteId}`,
    'session-settings-update',
  );

  const onSubmit = useEnableSessionCaptureConsent();

  return (
    <Container className={className}>
      <Text textType="subtitle1">{t('common:recordings.list.error-capturing-disabled.title')}</Text>
      <Subtitle textType="body2">
        {t('common:recordings.list.error-capturing-disabled.suggestion')}
      </Subtitle>

      {hasSessionSettingsUpdatePermission ? (
        <TrackingButton
          icon="code_tracking"
          onClick={() => onSubmit(siteId as number, onEnableCapture)}
        >
          {t('common:player.console-start-tracking-button')}
        </TrackingButton>
      ) : (
        <Subtitle textType="body2">{t('common:player.console-only-admins-allowed')}</Subtitle>
      )}
    </Container>
  );
};
